import React from 'react'
const NotFoundPage = () => (
  <h1>404</h1>
);
export default NotFoundPage;